import { Box, Button } from "@mui/material";

export default function ModalActions({
  onCancel,
  onSubmit,
  onDelete,
  cancelLabel = "Cancelar",
  submitLabel = "Guardar",
  deleteLabel = "Eliminar",
  loading = false,
  loadingDelete = false,
}: {
  onCancel: () => void;
  onSubmit: () => void | Promise<void>;
  onDelete?: () => void | Promise<void>;
  cancelLabel?: string;
  submitLabel?: string;
  deleteLabel?: string;
  loading?: boolean;
  loadingDelete?: boolean;
}) {
  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        backgroundColor: "#fff",
        p: 2,
        px: 3,
        borderTop: "1px solid #e5e7eb",
        display: "flex",
        justifyContent: onDelete ? "space-between" : "flex-end",
        alignItems: "center",
        gap: 2,
        zIndex: 10,
      }}
    >

      {/* IZQUIERDA – ELIMINAR */}
      {onDelete && (
        <Button
          variant="contained"
          onClick={onDelete}
          disabled={loadingDelete}
          sx={{
            backgroundColor: loadingDelete ? "#7a1f1f" : "#dc2626",
            color: "#fff",
            fontSize: "12px",
            minHeight: 35,
            height: 35,
            px: 2.5,
            textTransform: "none",
            boxShadow: "none",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#b91c1c",
              boxShadow: "none",
            },
          }}
        >
          {loadingDelete ? "Eliminando..." : deleteLabel}
        </Button>
      )}

      {/* DERECHA – CANCELAR / GUARDAR */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          onClick={onCancel}
          sx={{
            backgroundColor: "#ececec",
            color: "#0e0e0e",
            fontSize: "12px",
            minHeight: 35,
            height: 35,
            px: 2.2,
            textTransform: "none",
            boxShadow: "none",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: "#d4d3d3",
              boxShadow: "none",
            },
          }}
        >
          {cancelLabel}
        </Button>

        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={loading}
          sx={{
            backgroundColor: loading ? "#555" : "#000",
            textTransform: "none",
            fontSize: "12px",
            minHeight: 35,
            height: 35,
            px: 3,
            boxShadow: "none",
            borderRadius: "10px",
            "&:hover": {
              backgroundColor: loading ? "#555" : "#222",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Procesando..." : submitLabel}
        </Button>
      </Box>
    </Box>
  );
}
